import * as types from "src/store/types/clientes";

const INITIAL_STATE = {
  loading: false,
  clientes: [],
  page: 1,
  per_page: 10,
  total: 0,
  extrato: [],
  filtro: {
    nome: "",
    cep: "",
    uf: "",
    cidade: "",
    distancia: "",
  },
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.EMP_CLIENTES_LOADING:
      return { ...state, loading: action.payload };
    case types.EMP_CLIENTES_SET_FILTRO:
      return { ...state, filtro: { ...state.filtro, ...action.payload } };
    case types.EMP_CLIENTES_SET_LISTA:
      return { ...state, clientes: action.payload };
    case types.EMP_CLIENTES_SET_PAGE:
      return { ...state, page: action.payload };
    case types.EMP_CLIENTES_SET_PERPAGE:
      return { ...state, per_page: action.payload };
    case types.EMP_CLIENTES_SET_TOTAL:
      return { ...state, total: action.payload };
    case types.EMP_CLIENTES_SET_EXTRATO:
      return { ...state, extrato: action.payload };
    default:
      return state;
  }
};
